export const CARD_VARIANT = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const HEADER_VARIANT = {
  STATIC: 'static',
  FLOAT: 'float',
};
